import { unit } from '@ant-design/cssinjs';
const genStepsProgressStyle = token => {
  const {
    antCls,
    componentCls,
    iconSize,
    iconSizeSM,
    processIconColor,
    marginXXS,
    lineWidthBold,
    lineWidth,
    paddingXXS
  } = token;
  const progressSize = token.calc(iconSize).add(token.calc(lineWidthBold).mul(4).equal()).equal();
  const progressSizeSM = token.calc(iconSizeSM).add(token.calc(token.lineWidth).mul(4).equal()).equal();
  return {
    ["&".concat(componentCls, "-with-progress")]: {
      ["".concat(componentCls, "-item")]: {
        paddingTop: paddingXXS,
        ["&-process ".concat(componentCls, "-item-container ").concat(componentCls, "-item-icon ").concat(componentCls, "-icon")]: {
          color: processIconColor
        }
      },
      ["&".concat(componentCls, "-vertical > ").concat(componentCls, "-item ")]: {
        paddingInlineStart: paddingXXS,
        ["> ".concat(componentCls, "-item-container > ").concat(componentCls, "-item-tail")]: {
          top: marginXXS,
          insetInlineStart: token.calc(iconSize).div(2).sub(lineWidth).add(paddingXXS).equal()
        }
      },
      ["&, &".concat(componentCls, "-small")]: {
        ["&".concat(componentCls, "-horizontal ").concat(componentCls, "-item:first-child")]: {
          paddingBottom: paddingXXS,
          paddingInlineStart: paddingXXS
        }
      },
      ["&".concat(componentCls, "-small").concat(componentCls, "-vertical > ").concat(componentCls, "-item > ").concat(componentCls, "-item-container > ").concat(componentCls, "-item-tail")]: {
        insetInlineStart: token.calc(iconSizeSM).div(2).sub(lineWidth).add(paddingXXS).equal()
      },
      ["&".concat(componentCls, "-label-vertical ").concat(componentCls, "-item ").concat(componentCls, "-item-tail")]: {
        top: token.calc(iconSize).div(2).add(paddingXXS).equal()
      },
      ["".concat(componentCls, "-item-icon")]: {
        position: 'relative',
        ["".concat(antCls, "-progress")]: {
          position: 'absolute',
          insetInlineStart: '50%',
          top: '50%',
          transform: 'translate(-50%, -50%)',
          '&-inner': {
            width: "".concat(unit(progressSize), " !important"),
            height: "".concat(unit(progressSize), " !important")
          }
        }
      },
      // ============================== Small size ==============================
      ["&".concat(componentCls, "-small")]: {
        ["&".concat(componentCls, "-label-vertical ").concat(componentCls, "-item ").concat(componentCls, "-item-tail")]: {
          top: token.calc(iconSizeSM).div(2).add(paddingXXS).equal()
        },
        ["".concat(componentCls, "-item-icon ").concat(antCls, "-progress-inner")]: {
          width: "".concat(unit(progressSizeSM), " !important"),
          height: "".concat(unit(progressSizeSM), " !important")
        }
      }
    }
  };
};
export default genStepsProgressStyle;